
<app-content-render-legal-document-sign *ngIf="path || instanceId" [path]="path" [redirect]="redirect" [instanceId]="instanceId"></app-content-render-legal-document-sign>